import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./DoctorNoticeRegister.css";
import { formatDate } from "../../../../../components/Util/DateFormat";
import axios from "axios";
import Swal from "sweetalert2";
import { getServerBaseUrl } from "../../../../../utils/portConfig";
import Editor from "../../../../../components/Dashboard/Editor";

function DoctorNoticeRegister({ patientData, fromMokLok }) {
  // 초기 주치의 소견 데이터
  const initialDrNotice = {
    id: "",
    patientId: "",
    comments: "",
  };

  // State 변수 선언
  const [patientId, setPatientId] = useState("");
  const [drNoticeData, setDrNoticeData] = useState({ ...initialDrNotice });
  const navigate = useNavigate();

  const API_SERVER_URL = `${getServerBaseUrl()}/api/v1`;
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userid");

  // 환자 데이터가 변경될 때 실행되는 useEffect
  useEffect(() => {
    if (patientData) {
      setPatientId(patientData != null ? patientData.id : null);
      setDrNoticeData({ ...initialDrNotice });
    }
  }, [patientData]);

  // 에디터 ref 선언
  const editorRef = useRef(null);

  // 첨부파일
  const handleFileChange = (event) => {
    const file = event.target.files[0];
  };

  // 주치의소견 - 저장 버튼
  const drNoticeSaveChartButton = () => {
    drNoticeData.patientId = patientId;
    // 저장 시점에 현재 에디터 내용을 가져와서 저장
    let updateContents = "";

    if (editorRef.current) {
      const html = editorRef.current.getHTML();
      updateContents = html;
    }

    if (updateContents === "" || updateContents === "<p><br></p>") {
      showWarningAlert("차트 코멘트를 입력해 주세요.");
      return;
    }
    // 소견 생성 함수
    createDrNotice(updateContents);
  };

  // 주치의 소견 - 취소 버튼
  // doctorNotice 줄여서 dNotice
  const dNoticeCancelChartButton = () => {
    navigate("/", { state: { setActiveMenu: "환자정보전달", tabFlag: "소견취소" } });
  };

  //주치의 소견 생성
  const createDrNotice = (updateContents) => {
    const fileInput = document.getElementById("drnoticeInputId").files[0];
    const formData = new FormData();
    formData.append("comments", updateContents);
    if (fileInput !== undefined) {
      formData.append("files", fileInput);
    }

    axios
      .post(`${API_SERVER_URL}/notice/${drNoticeData.patientId}/create/${userId}`, formData, { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } })
      .then((response) => {
        if (response.status === 201) {
          showSuccessAlert("소견이 등록되었습니다.");
          setDrNoticeData({ ...initialDrNotice });
          navigate("/", { state: { setActiveMenu: "환자정보전달", tabFlag: "소견취소" } });
        } else {
          showErrorAlert("실패", "소견 등록 실패. 다시 시도해주세요.");
        }
      })
      .catch((error) => {
        console.error("Error creating drNotice", error);
        if (error.response) {
          const responseData = error.response.data;
          if (responseData) {
            showErrorAlert("소견 등록 오류", responseData);
          } else {
            showErrorAlert("서버 응답 오류", `서버 응답 오류: ${error.response.status}`);
          }
        } else {
          showErrorAlert("서버 응답이 없습니다.", "서버 응답이 없습니다.");
        }
      });
  };

  /* 메세지 공통 함수*/
  const showSuccessAlert = (text) => {
    Swal.fire({
      icon: "success",
      title: "성공",
      text: text,
      customClass: {
        popup: "custom-swal-popup",
      },
    });
  };

  const showErrorAlert = (title, text) => {
    Swal.fire({
      icon: "error",
      title: title,
      text: text,
      customClass: {
        popup: "custom-swal-popup",
      },
    });
  };

  const showWarningAlert = (text) => {
    Swal.fire({
      icon: "warning",
      title: "알림",
      text: text,
      customClass: {
        popup: "custom-swal-popup",
      },
    });
  };

  return (
    <div style={{ padding: "2px", width: "100%", height: "100%" }}>
      <div className="right-group">
        <div className="content-select-container">
          <label>소견 등록일: {fromMokLok === "소견등록" ? <span>{formatDate(new Date()).replace(".", "-").replace(".", "-")}</span> : <span>아직 구현 안됌</span>}</label>
        </div>
        <div className="content-quill-container" style={{ fontWeight: "400" }}>
          <Editor ref={editorRef} readOnly={false} initialHTML={drNoticeData.comments} />
        </div>
        <div className="drnotice-attachment-container">
          <label>첨부파일</label>
          <input type="file" id="drnoticeInputId" name="drnoticeInput" onChange={handleFileChange} />
        </div>
        <div className="content-button-container">
          <button className="drnotice-save-button" onClick={drNoticeSaveChartButton}>
            저장
          </button>
          <button className="drnotice-delete-button" onClick={dNoticeCancelChartButton}>
            취소
          </button>
        </div>
      </div>
    </div>
  );
}

export default DoctorNoticeRegister;
